<template>
    <label
        :id="id"
        class="pt-checkbox"
        :class="[
            checkboxSize ? 'pt-checkbox--' + checkboxSize : '',
            theme ? 'pt-checkbox--theme-' + theme : '',
            { 'is-disabled': isDisabled },
            { 'is-bordered': border },
            { 'is-checked': isChecked },
        ]"
        :aria-controls="indeterminate ? controls : null"
    >
        <span
            class="pt-checkbox__input"
            :class="{
                'is-disabled': isDisabled,
                'is-checked': isChecked,
                'is-indeterminate': indeterminate,
                'is-focus': focus,
            }"
            :tabindex="indeterminate ? 0 : false"
            :role="indeterminate ? 'checkbox' : false"
            :aria-checked="indeterminate ? 'mixed' : false"
        >
            <span class="pt-checkbox__inner"></span>
            <input
                v-if="trueLabel || falseLabel"
                v-model="model"
                :checked="isChecked"
                class="pt-checkbox__original"
                type="checkbox"
                :aria-hidden="indeterminate ? 'true' : 'false'"
                :name="name"
                :disabled="isDisabled"
                :true-value="trueLabel"
                :false-value="falseLabel"
                @change="handleChange"
                @focus="focus = true"
                @blur="focus = false"
            />
            <input
                v-else
                v-model="model"
                class="pt-checkbox__original"
                type="checkbox"
                :aria-hidden="indeterminate ? 'true' : 'false'"
                :disabled="isDisabled"
                :value="label"
                :name="name"
                @change="handleChange"
                @focus="focus = true"
                @blur="focus = false"
            />
        </span>
        <span v-if="$slots.default || label" class="pt-checkbox__label">
            <slot></slot>
            <template v-if="!$slots.default">{{ label }}</template>
        </span>
    </label>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { UPDATE_MODEL_EVENT } from '../../../utils/constants';
import { isValidComponentSize } from '../../../utils/validators';
import { useCheckbox } from './useCheckbox';

export default defineComponent({
    name: 'PtCheckbox',
    props: {
        modelValue: {
            type: [Boolean, Number, String],
            default: () => undefined,
        },
        label: {
            type: [String, Boolean, Number, Object],
        },
        indeterminate: Boolean,
        disabled: Boolean,
        checked: Boolean,
        name: {
            type: String,
            default: undefined,
        },
        trueLabel: {
            type: [String, Number],
            default: undefined,
        },
        falseLabel: {
            type: [String, Number],
            default: undefined,
        },
        id: {
            type: String,
            default: undefined,
        },
        controls: {
            type: String,
            default: undefined,
        },
        border: Boolean,
        size: {
            type: String as PropType<ComponentSize>,
            validator: isValidComponentSize,
        },
        theme: {
            type: String,
            default: '',
        },
    },
    emits: [UPDATE_MODEL_EVENT, 'change'],
    setup(props) {
        return useCheckbox(props);
    },
});
</script>
<style lang="scss" src="../style/checkbox.scss" />
